module.exports = __webpack_public_path__ + "static/media/Bill (1).81afe33f.svg";